import {client as http, axiosInstance} from "@/http_client";
import async from "async";
import moment from "moment";

export default {
    state: {
        registration: null
    },
    getters: {
        registration: state => state.registration
    },
    mutations: {},
    actions: {
        getRegistrationById({state}, id) {
            console.log('vuex:getRegistrationById', id);
            return new Promise((resolve, reject) => {

                let registration;

                async.series([
                    (cb) => {
                        http.get('app/registrations/' + id, {force: true}).then(response => {
                            registration = response.data;
                            cb()
                        }).catch(err => {
                            console.log(err);
                            cb(err)
                        });
                    }
                ], err => {
                    if (err) {
                        console.log('err', err);
                        reject(err.response);
                        return;
                    }

                    // Determine if there are required or incomplete applications/forms /////////////////////////////////
                    registration.isIncompleteApps = false;
                    registration.isLocked = true;

                    for (let confApp of registration.conference.applications) {
                        let regApplication = registration.applications.find(enrollApp => {
                            return enrollApp.conf_application_id == confApp.id;
                        });

                        if (moment(registration.conference.start_at).isBefore(moment())
                                && registration.reg_record_log.length > 0
                                && confApp.is_required_at_end
                                && !regApplication || (regApplication && !regApplication.completed_at)) {
                            registration.isIncompleteApps = true;
                            registration.isLocked = false;
                            break;
                        }

                        // Determine if there is anything else to do
                        if (!regApplication || (regApplication && !regApplication.completed_at)) {
                            registration.isLocked = false;
                            break;
                        }
                    }

                    registration.isPreRegistration = moment().isBefore(moment(registration.conference.start_at));

                    // Complete, set and send back registration ///////////////////////////////////////////////////////////
                    state.registration = registration;

                    resolve(registration);
                });

            });
        },
    }
};
